import { ListTodo } from 'lucide-react';

export default function TaskList() {
  return (
    <div className="w-full flex-1 space-y-3 overflow-y-auto rounded-md border p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <ListTodo className="mr-2 h-5 w-5 text-yellow-700" />
          <p className="text-lg font-semibold">Pending Tasks</p>
        </div>
      </div>
    </div>
  );
}
